import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class ExpectedPriceRange extends RestResource {
  underlyingSymbol = ""
  underlyingInstrumentType = ""
  upPercent = 0
  downPercent = 0
  enabled = true
}

export const EXPECTED_PRICE_RANGE_DESER: SchemaDeSer<ExpectedPriceRange> =
  new SchemaDeSerBuilder(ExpectedPriceRange)
    .ofString("underlyingSymbol")
    .ofString("underlyingInstrumentType")
    .ofFloat("upPercent")
    .ofFloat("downPercent")
    .ofBoolean("enabled")
    .toDeSer()
